import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { deepPurpleMui } from "@ryde/theme";

export const QuickAddStationFormStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "quick-add-station-form",
})`
  gap: 10px;
  display: flex;
  flex-direction: column;
  border: 1px solid ${deepPurpleMui.A400};
  padding: 8px 8px 8px 10px;
  border-radius: 4px;
  margin-top: 9px;

  .quick-add-station-form__input-wrapper {
    display: flex;
    gap: 10px;
  }

  .quick-add-station-form__map-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .quick-add-station-form__controls {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
`;
